import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const API_KEY_STORAGE = 'bot_forge_api_key';
const ACCOUNT_ID_STORAGE = 'bot_forge_account_id';

export function getStoredApiKey() {
  return localStorage.getItem(API_KEY_STORAGE);
}

export function setStoredApiKey(apiKey) {
  localStorage.setItem(API_KEY_STORAGE, apiKey);
}

export function clearStoredApiKey() {
  localStorage.removeItem(API_KEY_STORAGE);
}

export function getStoredAccountId() {
  return localStorage.getItem(ACCOUNT_ID_STORAGE);
}

export function setStoredAccountId(accountId) {
  if (accountId) {
    localStorage.setItem(ACCOUNT_ID_STORAGE, accountId);
  } else {
    localStorage.removeItem(ACCOUNT_ID_STORAGE);
  }
}

export function clearStoredAccountId() {
  localStorage.removeItem(ACCOUNT_ID_STORAGE);
}

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const apiKey = getStoredApiKey();
  if (apiKey) {
    config.headers.Authorization = `Bearer ${apiKey}`;
  }
  const accountId = getStoredAccountId();
  if (accountId) {
    config.headers['X-Account-Id'] = accountId;
  }
  return config;
});

export default api;
